
import { Modal, ModalContent, ModalBody, Input, Button } from "@nextui-org/react";

const CommissionModel = ({ isOpen, onClose, rate, handleCommission, addCommission }) => {
  
  return (
    <Modal size={"xs"} isOpen={isOpen} onClose={onClose} placement="center">
      <ModalContent>
        {(onClose) => (
          <ModalBody>
            <div className="flex gap-2">
              <Input
                type="number"
                className="my-2"
                variant="bordered"
                label={"Enter Commission Rate"}
                labelPlacement={"outside"}
                placeholder="Enter commission rate"
                value={rate}
                onChange={handleCommission}
                />
               
            </div>
            <div className="grid grid-cols-2 gap-2 pb-3">
              <Button
                className="border-2 border-orange-500 text-orange-500 bg-transparent hover:bg-orange-500 hover:text-white hover:border-none"
                onClick={onClose}
              >
                Cancel
              </Button>
              <Button
                className="border-2 border-green-500 text-green-500 bg-transparent hover:bg-green-500 hover:text-white hover:border-none"
                onClick={addCommission}
              >
                Update
              </Button>
            </div>
          </ModalBody>
        )}
      </ModalContent>
    </Modal>
  );
};

export default CommissionModel;
